import PageErrorContent from "../../../app/PageErrorContent";
import { MobileAppPageErrorStyled } from './styled/MobileAppPageErrorStyled';

function MobileAppPageError(props) {
    const {
        children,
        ...pageErrorContentProps
    } = props;

    return <MobileAppPageErrorStyled>
        <PageErrorContent {...pageErrorContentProps}>
            {children}
        </PageErrorContent>
    </MobileAppPageErrorStyled>
}

export default MobileAppPageError;
